import { ActionsCell } from "../../../../Component/Common/Components/DataTable/ActionsCell";
import { ActionsCellWithBadge } from "../../../../Component/Common/Components/DataTable/ActionsCellWithBadge";
import { DefaultCell } from "../../../../Component/Common/Components/DataTable/DefaultCell";
import { CommitteeMinutes } from "../../../../Component/Model/Dto/EmploymentEquity/Committee";
import { TableDateHelper } from "../../../../Component/Model/helpers";
import { ActionType, TableColumn } from "../../../../Component/Model/Table/Table";

interface CommitteeMinutesRow {
    Id:                     string;
    Date:                   string;
    DateCreated:            string;
    CreatedBy:              string;
    DateLastModified:       string;
    LastModifiedBy:         string;
    SupportingDocuments:    any;
    Actions?:               ActionType[];
}

interface CommitteeMinutesTable {
    columns: Array<TableColumn>;
    rows: Array<CommitteeMinutesRow>;
}

export function CommitteeMinutesTableMapper(dataObject: CommitteeMinutes.SearchResponseRow[], handleEdit: (id: string) => void, handleDelete: (id: string) => void, handleAttachedSD: (id: string) => void, handleToggleDocumentPack: (id: string) => void): CommitteeMinutesTable {

    const columns = [
        { Header: 'Date', accessor: 'Date', id: "Date", Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true} />},
        { Header: 'Date Created', accessor: 'DateCreated', id: "CreatedDateUTC", Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true} />},
        { Header: 'Created By', accessor: 'CreatedBy', id:"CreatedBy", Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true} />},
        { Header: 'Date Last Modified', accessor: 'DateLastModified', id: "ModifiedBy",Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true} />},
        { Header: 'Last Modified By', accessor: 'LastModifiedBy', id: "ModifiedDateUTC",Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true} />, disableSortBy: true},
        { Header: 'Supporting Documents', accessor: 'SupportingDocuments', Cell: ({ value }: any) => <ActionsCellWithBadge actions={value}  key={value}/>, disableSortBy: true },
        { Header: 'Actions', accessor: 'Actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true },
    ];

    if (dataObject !== undefined && dataObject.length > 0) {

        const rows = dataObject.map((item: CommitteeMinutes.SearchResponseRow) => ({
            Id: item.id,
            Date: TableDateHelper(item.date),
            CreatedBy: item.createdBy,
            DateCreated: TableDateHelper(item.dateCreated),
            LastModifiedBy: item.lastModifiedBy,
            DateLastModified: TableDateHelper(item.dateLastModified),
            SupportingDocuments: item.documentsSelectedForDownload ? [
                { label: `${item.documentCount} Supporting Document(s)`, action: handleAttachedSD, key: item.id, icon: { color: 'info', name: 'attach_file' }, badgeCount: item.documentCount },
                // { label: 'Remove Documents from Download Pack', action: handleToggleDocumentPack, key: item.id, icon: { color: 'secondary', name: 'bookmark_remove' } }
            ] :
                [
                    { label: `${item.documentCount} Supporting Document(s)`, action: handleAttachedSD, key: item.id, icon: { color: 'info', name: 'attach_file' }, badgeCount: item.documentCount },
                    // { label: 'Add Documents to Download Pack', action: handleToggleDocumentPack, key: item.id, icon: { color: 'secondary', name: 'bookmark_add' } },
                ],
            Actions: [
                { label: 'View/Edit', action: handleEdit, key: item.id, icon: { color: 'info', name: 'edit' } },
                { label: 'Delete', action: handleDelete, key: item.id, icon: { color: 'error', name: 'delete' } }]
        }));

        return { columns: columns, rows: rows };

    } else {
        return { columns: columns, rows: [] };
    }
}